import renderHandlebarsTemplate from "../handlebars/renderHandlebarsTemplate";

export default async function generateOnixFromTemplate({ document }) {
	const { onixTemplate } = document.channel;

	return renderHandlebarsTemplate({ template: onixTemplate, data: document });
}
